import { render, staticRenderFns } from "./Hipmikab.vue?vue&type=template&id=556abaf2"
import script from "./Hipmikab.vue?vue&type=script&lang=js"
export * from "./Hipmikab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports